const s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 8c.566 0 .743-.339.815-.746a4.251 4.251 0 1 1 7.234 3.707q-.27.277-.573.577c-.614.613-1.295 1.294-1.852 2.009-.75.963-1.374 2.108-1.374 3.453v.492a.75.75 0 0 0 1.5 0V17c0-.864.399-1.685 1.058-2.532.494-.634 1.077-1.217 1.673-1.813q.322-.32.644-.649A5.75 5.75 0 1 0 6.32 7.105C6.247 7.559 6.483 8 7 8m5 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></svg>';
export {
  s as w
};
